export const PROJECTS_DATE_FORMAT = 'MMM d';

export enum ProjectTab {
  Overview = 'overview',
  Tickets = 'tickets',
  Tasks = 'tasks',
  ActionItems = 'actionItems',
  Files = 'files',
}

export type ProjectsRouteParams = {
  tab?: ProjectTab;
  projectId: string;
  ticketId?: string;
  taskId?: string;
};
